import React, { useEffect } from "react";
import "../style/Plans/YourPlan.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactComponent as Assistence } from "../assets/new-icons/assistenza.svg";
import { ReactComponent as SadFace } from "../assets/new-icons/tradizionaleFace.svg";
import { ReactComponent as RelaxFace } from "../assets/new-icons/relaxFace.svg";
import { ReactComponent as HappyFace } from "../assets/new-icons/ricaricabileFace.svg";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PriceBox from '../components/PlanBoxs/PriceBox';
import TagliaBox from '../components/PlanBoxs/TagliaBox';
import TagliaSogliaBox from '../components/PlanBoxs/TagliaSogliaBox';
import PaymentBox from '../components/PlanBoxs/PaymentBox';
import ChooseBox from '../components/PlanBoxs/ChooseBox';

function YourPlan() {
  const navigate = useNavigate();
  const prezzoNegativo = useSelector(
    (user) => user.user.nuoviDatiContratto.mono_negativo
  );
  const currentPlan = useSelector((user) => user?.user?.idGruppo);
  const [scroll, setScroll] = React.useState(false)

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > window.innerHeight / 3
        if(scrollCheck){
            setScroll(true)
        } else {
            setScroll(false)
        }
    })

  
  }, [])

  const getPlanName = () => {
    switch (currentPlan) {
      case 1:
        return "Ricaricabile";
      case 2:
        return "Relax";

      case 3:
        return "Tradizionale";
      default:
        break;
    }
  };
  const getPlanFace = () => {
    switch (currentPlan) {
      case 1:
        return <HappyFace />;
      case 2:
        return <RelaxFace />;

      case 3:
        return <SadFace />;
      default:
        break;
    }
  };
  const getPlanDescription = () => {
    switch (currentPlan) {
      case 1:
        return "Ogni volta che il tuo saldo, compreso dei consumi quotidiani, scende sotto la soglia impostata, ricaricheremo la taglia scelta dal tuo metodo di pagamento preferito";
      case 2:
        return "Il piano Relax è l'ideale per te che desideri risparmiare sul prezzo al kWh con 2 ricariche al mese: entro il 5 ricarichi una taglia pari al tuo consumo medio mensile, entro il 20 la differenza.";

      case 3:
        return "E' pensato per te che desideri pagare i consumi alla scadenza naturale della fattura. Non anticipi il pagamento e paghi il prezzo al kWh standard di listino senza bonus o sconti.";
      default:
        break;
    }
  };
  return (
    <div className={`yourPlane ${currentPlan === 3 ? 'red' : currentPlan === 2 ? 'orange' : 'green'}`}>
      <div className="yourPlane-top">
        <header>
          <div className="navigation" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </div>
          <div className="assistence">
            <Assistence />
          </div>
        </header>
        {scroll ? (
          <header className='fixed'>
            <div className="navigation" onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </div>
            <div className="assistence">
              <Assistence />
            </div>
          </header>
        ) : null}
        <div className="text">
          <p className="label">Il tuo piano</p>
          <div className="flex">
            <p className="main epilogue">{getPlanName()}</p>
            <div className="icon">{getPlanFace()}</div>
          </div>
          <p className="secondary">{getPlanDescription()}</p>
          <div
            className="moreInfo"
            onClick={() => navigate("/enrica/dettagli-piano")}
          >
            <p className="more">Scopri di più sul tuo piano</p>
            <ArrowForwardIos />
          </div>
        </div>
      </div>
      <div className="yourPlane-bottom">
        <PriceBox price={prezzoNegativo} currentPlan={currentPlan} getPlanName={getPlanName()}/>
        <TagliaBox currentPlan={currentPlan} />
        <TagliaSogliaBox currentPlan={currentPlan} />
        <PaymentBox />
        <ChooseBox   />
      </div>
    </div>
  );
}

export default YourPlan;
